import React, { useMemo } from 'react';
import { useEffect, useState } from 'react';

// Firebase
import db from './firebase';
import { collection, doc, getDoc, getDocs, query, setDoc, where } from "firebase/firestore";

// Components
import Header from './components/Header';
import Main from './components/Main';
import Footer from './components/Footer';
import PasswordPopup from './components/PasswordPopup';
import ShiftChangeRequestForm from './components/ShiftChangeRequestForm';

// Material UI
import { Container } from '@mui/material';

// CSS
import './App.css';



function App() {

  // 次月に関する基本情報
  const nextMonthYear = useMemo(() => {
      const today = new Date();
      const nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1);
    
      const yyyy = nextMonth.getFullYear();
      let mm = nextMonth.getMonth() + 1;
      const daysInMonth = new Date(yyyy, mm, 0).getDate(); // 月の日数

      // 土日のインデックスを計算する
    const weekends = [];
    const saturdays = [];
    const sandays = [];
    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(yyyy, mm - 1, day);
      const dayOfWeek = date.getDay();
      if (dayOfWeek === 6) {
          saturdays.push(day - 1);
          weekends.push(day - 1);
      } else if (dayOfWeek === 0) {
          sandays.push(day - 1);
          weekends.push(day - 1);
      }
    }

      return { 
        "yyyy": yyyy, 
        "mm": mm, 
        "daysInMonth": daysInMonth, 
        "土日": weekends,
        "土曜": saturdays,
        "日曜": sandays,
        "thisyyyy": mm === 1 ? yyyy - 1 : yyyy,
        "thismm": mm === 1 ? 12 : mm - 1
      };
  }, []);


  // 従業員CD一覧
  const [ employeeCodeList, setEmployeeCodeList ] = useState([]);

  // シフトパターン一覧
  const [ shiftOptionList, setShiftOptionList ] = useState([]);
  
  // 従業員情報
  const [ employeeCode, setEmployeeCode ] = useState('');
  // const [ locationCode, setLocationCode ] = useState('');
  const [ employeeShiftInfo, setEmployeeShiftInfo ] = useState({});
  const [ hasRegisteredShifts, setHasRegisteredShifts ] = useState(false);
  const [ shiftSubmitPassword, setShiftSubmitPassword ] = useState("");

  // 勤務情報
  const [ shiftPattern, setShiftPattern ] = useState({});
  const [ shiftTable, setShiftTable ] = useState([
    ["記号", "勤務時間", "出勤時間", "退勤時間"]
  ]);

  // 従業員番号が有効かどうか
  const [ employeeCodeIsValid, setEmployeeCodeIsValid ] = useState(false);

  // 入力された従業員情報が変化したかどうかのフラグ
  const [ employeeChanged, setEmployeeChanged ] = useState(false);


  // 希望シフト
  const [ selectedShiftValues, setSelectedShiftValues ] = useState(Array(nextMonthYear["daysInMonth"]).fill(''));
  const [ selectedShiftHourValues, setSelectedShiftHourValues ] = useState(Array(nextMonthYear["daysInMonth"]).fill(''));
  const [ updatedAt, setUpdatedAt ] = useState('-');
  
  // シフト登録時のバリデーション
  const [ pastDeadLine, setPastDeadLine ] = useState(false);
  const [ workHourValidationIsOK, setWorkHourValidationIsOK ] = useState(true);
  const [ weekendValidationIsOK, setWeekendValidationIsOK ] = useState(true);
  const [ paidLeaveCountIsOK, setPaidLeaveCountIsOK ] = useState(true);
  const [ workableCount, setWorkableCount ] = useState(0);
  const [ monthlyMinHours, setMonthlyMinHours ] = useState(0);
  const [ defaultMonthlyMinHours, setDefaultMonthlyMinHours ] = useState(0);

  // 特別勤務形態
  const [ approvedSpecialShift, setApprovedSpecialShift ] = useState({ "weekends": -1, "hour": -1 });
  const [ specialShiftPattern, setSpecialShiftPattern ] = useState([]);

  // パスワード設定ポップアップ
  const [ passwordPopupOpen, setPasswordPopupOpen ] = useState(false);

  // 今月、翌月の切替タブ
  const [ activeTab, setActiveTab ] = useState("next"); // next or change

  // シフヘン情報
  const [ shiftChanges, setShiftChanges ] = useState({
    "current": {"shift_changes": []},
    "next": {"shift_changes": []}
  });

  // シフヘン制限者
  const [ shiftChangeLimitEmps, setShiftChangeLimitEmps ] = useState([]);

  // 従業員一覧をDBから取得: 初回のみ
  useEffect(() => {

    async function getEmployeeCodeList() {
        const docSnap_emp = await getDoc(doc(db, "Config", "employees"));
        const allEmpCodeList = docSnap_emp.data()['employee_code'];
        setEmployeeCodeList(allEmpCodeList);

        const docSnap_shiftOption = await getDoc(doc(db, "Config", "shiftOptions"));
        const allShiftOptionList = docSnap_shiftOption.data()['shift_options'];
        setShiftOptionList(allShiftOptionList);
    }
    getEmployeeCodeList();
    
  }, []);


  // 有効な従業員番号が入力された場合、データ取得
  useEffect(() => {

    async function getEmployeeData() {

      const q = query(collection(db, "Employees"), where("employee_code", "==", employeeCode));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const docSnap = querySnapshot.docs[0];
        setEmployeeShiftInfo(docSnap.data());
        setShiftSubmitPassword(docSnap.data()["password"]);
      } else {
        alert("従業員番号がデータベースに登録されていません。管理者へ問い合わせてください。");
      }
    }

    async function getShiftChangesLimitEmps() {

      const locationKey = employeeCode[0];
      const docRef = doc(db, "ShiftChangesLimit", locationKey);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setShiftChangeLimitEmps(docSnap.data()["empIds"]);
      } else {
        alert("不測のエラーが発生しました。時間をおいて再度試すか、管理者へ問い合わせてください。");
      }
    }

    employeeCodeIsValid && employeeChanged && getEmployeeData();
    employeeCodeIsValid && employeeChanged && getShiftChangesLimitEmps();

  // eslint-disable-next-line
  }, [employeeCodeIsValid, employeeCode]);


  // 締め日を取得
  useEffect(() => {

    async function checkDeadLine() {
      
      const year = nextMonthYear["yyyy"];
      const month = nextMonthYear["mm"];
      const locationKey = employeeCode[0];

      const q = query(collection(db, "Config"),
        where("year", "==", year),
        where("month", "==", month),
        where("location_key", "==", locationKey)
      );
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const docSnap = querySnapshot.docs[0].data();
        const deadLine = docSnap["deadLine"];
        const deadLineDate = Number(deadLine.split("-")[2]);
        const today = new Date();
        const todayDate = today.getDate();
        if (todayDate > deadLineDate) {
          setPastDeadLine(true);
        } else {
          setPastDeadLine(false);
        }
      } else {
        setPastDeadLine(false);
      }
    }

    employeeCodeIsValid && employeeChanged && checkDeadLine();

  // eslint-disable-next-line
  }, [employeeCodeIsValid, employeeCode]);


  // 基本シフトをDBから取得、整理
  // 登録済みシフトを取得、初期化
  useEffect(() => {
    
    async function getEmployeeShift() {
      
      const shiftPatternsForTheMD = [ ...new Set([...employeeShiftInfo["shift_patterns"], ...specialShiftPattern]) ];

      if (shiftPatternsForTheMD.length > 0) {
        const q = query(collection(db, "ShiftPatterns"), where("shift_code", "in", shiftPatternsForTheMD));
        const querySnapshot = await getDocs(q);
        
        if (!querySnapshot.empty) {
            let shiftPatternObj = {};
            let shiftTableContent = [];
            let valueCounts = {};
            let valueCounters = {};
            
            // まずは各値の出現回数をカウント
            for (let doc of querySnapshot.docs) {
              const data = doc.data();
              const workHour_H = data["work_hour"] + "H";
              valueCounts[workHour_H] = (valueCounts[workHour_H] || 0) + 1;
              valueCounters[workHour_H] = 0;
            }

            for (let doc of querySnapshot.docs) {
              const data = doc.data();
              const shiftCode = data["shift_code"];
              const workHour_H = data["work_hour"] + "H";
              const workHour_Jikan = data["work_hour"] + "時間";
              const startTime = data["start_time"];
              const endTime = data["end_time"];

              if (valueCounts[workHour_H] > 1) {
                valueCounters[workHour_H]++;
                shiftPatternObj[shiftCode] = `${workHour_H}-${valueCounters[workHour_H]}`;
                shiftTableContent.push([`${workHour_H}-${valueCounters[workHour_H]}`, workHour_Jikan, startTime, endTime]);
              } else {
                shiftPatternObj[shiftCode] = workHour_H;
                shiftTableContent.push([workHour_H, workHour_Jikan, startTime, endTime]);
              }

            }

            // 翌月分（希望シフト提出用）
            shiftTableContent.sort((a, b) => sortByHourAndNumber(a[0], b[0]));

            // shiftPatternObjのエントリをソート
            let entries = Object.entries(shiftPatternObj);
            entries.sort((a, b) => sortByHourAndNumber(a[1], b[1]));

            const defaultShiftCode = entries[0][0];
            const defaultShiftHour = entries[0][1];
            shiftPatternObj = Object.fromEntries(entries);
            
            setShiftPattern({...shiftPatternObj});
            setShiftTable([
              ["記号", "勤務時間", "出勤時間", "退勤時間"],
              ...shiftTableContent
            ]);
  
            // シフトの初期化
            const year = nextMonthYear["yyyy"];
            const month = nextMonthYear["mm"];
            const monthStr = month < 10 ? "0" + month : month;
  
            const docName = `${year}${monthStr}${employeeCode}`;
            const docRef = doc(db, "RequestShifts", docName);
            const docSnap = await getDoc(docRef);
  
            if (docSnap.exists()) {
              const savedShiftCodeList = docSnap.data()["requested_shifts"];
              const savedShiftHourList = savedShiftCodeList.map((code) => {
                if (code === 'x' || code === 'pto') {
                  return '0H';
                } else {
                  return shiftPatternObj[code]
                }
              });
              
              if (savedShiftHourList.includes(undefined)) {
                setSelectedShiftValues(Array(nextMonthYear["daysInMonth"]).fill(defaultShiftCode || ''));
                setSelectedShiftHourValues(Array(nextMonthYear["daysInMonth"]).fill(defaultShiftHour || ''));
              } else {
                setSelectedShiftValues(savedShiftCodeList);
                setSelectedShiftHourValues(savedShiftHourList);
              }
              
              // 前回登録日をyyyy/mm/dd形式に変換
              const updatedAt = docSnap.data()["updated_at"];
              const updatedDate = new Date(updatedAt["seconds"]*1000);
  
              const year = updatedDate.getFullYear();
              const month = updatedDate.getMonth() + 1;
              const day = updatedDate.getDate();
              const hours = updatedDate.getHours();
              const minutes = updatedDate.getMinutes();
  
              const pad = (num) => num.toString().padStart(2, '0');
              const formattedUpdatedAt = `${year}/${pad(month)}/${pad(day)} ${pad(hours)}:${pad(minutes)}`;
              setUpdatedAt(formattedUpdatedAt);
  
            } else {
              setSelectedShiftValues(Array(nextMonthYear["daysInMonth"]).fill(defaultShiftCode || ''));
              setSelectedShiftHourValues(Array(nextMonthYear["daysInMonth"]).fill(defaultShiftHour || ''));
              setUpdatedAt("-");
            }
            setHasRegisteredShifts(true);
        } else {
          setHasRegisteredShifts(false);
          setShiftPattern({});
          setShiftTable([
            ["記号", "勤務時間", "出勤時間", "退勤時間"]
          ]);
          alert("無効なシフトパターンが登録されています。管理者へ問合わせてください。");
        }
      } else {
        setHasRegisteredShifts(false);
        setShiftPattern({});
        setShiftTable([
          ["記号", "勤務時間", "出勤時間", "退勤時間"]
        ]);
        alert("シフトパターンが登録されていません。管理者へ問合わせてください。");
      }
    }

    employeeCodeIsValid && employeeChanged && getEmployeeShift();
  
  // eslint-disable-next-line
  }, [employeeShiftInfo, specialShiftPattern]);


  const sortByHourAndNumber = (a, b) => {
    
    const hourA = parseFloat(a.split('-')[0], 10);
    const hourB = parseFloat(b.split('-')[0], 10);
  
    if (hourA !== hourB) {
      return hourB - hourA; // 時間部分でソート
    }
  
    // 番号部分を抽出
    const numberA = parseFloat(a.split('-')[1] || 0, 10);
    const numberB = parseFloat(b.split('-')[1] || 0, 10);
  
    return numberA - numberB; // 番号部分でソート
  }
  



  // 特別勤務情報を取得
  useEffect(() => {

    async function getSpecialShiftData() {

      // 翌月分（希望シフト提出用）
      const year = nextMonthYear["yyyy"];
      const month = nextMonthYear["mm"];
      const locationKey = employeeCode[0];
      
      const q = query(collection(db, "SpecialShiftManagement"), 
        where("year", "==", year),
        where("month", "==", month),
        where("location_key", "==", locationKey)
      );
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        setApprovedSpecialShift({ "weekends": -1, "hour": -1 });
        setSpecialShiftPattern([]);
        return;
      }
      const docSnap = querySnapshot.docs[0];
      const specialShiftData = docSnap.data();

      const approvedWeekendDateList = specialShiftData["weekend"];
      const approvedMonthlyHourList = specialShiftData["monthly_hour"];
      const approvedSpecialShiftList = specialShiftData["shift_pattern"];

      let approvedWeekendCount = -1;
      let fixedWorkHour = -1;
      let specialShiftPatternList = [];

      if (approvedWeekendDateList && approvedWeekendDateList[employeeCode] >= 0) {
        approvedWeekendCount = approvedWeekendDateList[employeeCode];
      }

      if (approvedMonthlyHourList && approvedMonthlyHourList[employeeCode] >= 0) {
        fixedWorkHour = approvedMonthlyHourList[employeeCode];
      }
      setApprovedSpecialShift({ "weekends": approvedWeekendCount, "hour": fixedWorkHour });

      if (approvedSpecialShiftList && approvedSpecialShiftList[employeeCode]) {
        specialShiftPatternList = approvedSpecialShiftList[employeeCode];
      }
      setSpecialShiftPattern(specialShiftPatternList);

    }

    employeeCodeIsValid && employeeChanged && getSpecialShiftData();

  // eslint-disable-next-line
  }, [employeeShiftInfo]);



   // シフヘン情報を取得
   useEffect(() => {

    async function getShiftChanges() {

      // 翌月分（希望シフト提出用）
      const thisYear = nextMonthYear["thisyyyy"];
      const thisMonth = nextMonthYear["thismm"];
      const thisMonthStr = thisMonth < 10 ? "0" + thisMonth : thisMonth;

      const nextYear = nextMonthYear["yyyy"];
      const nextMonth = nextMonthYear["mm"];
      const nextMonthStr = nextMonth < 10 ? "0" + nextMonth : nextMonth;

      // 現在の日付を取得
      // const today = new Date();
      // const currentDate = today.getDate();

      // 取得する月のデータを設定
      const monthsToFetch = [
        { year: thisYear, month: thisMonthStr },
        { year: nextYear, month: nextMonthStr }
      ];

      // 25日以降なら翌月分も取得
      // if (currentDate >= 25) {
      //   monthsToFetch.push({ year: nextYear, month: nextMonthStr });
      // }

      let allShiftChanges = {
        current: { shift_changes: [] },
        next: { shift_changes: [] }
      };

      // 各月のデータを取得
      for (const monthData of monthsToFetch) {
        const docName = `${monthData.year}${monthData.month}${employeeCode}`;
        const docRef = doc(db, "ShiftChanges", docName);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const savedShiftChangeData = docSnap.data();
          if (monthData.month === thisMonthStr) {
            allShiftChanges.current = savedShiftChangeData;
          } else {
            allShiftChanges.next = savedShiftChangeData;
          }
        }
      }

      setShiftChanges(allShiftChanges);
    }

    employeeCodeIsValid && employeeChanged && getShiftChanges();

  // eslint-disable-next-line
  }, [employeeShiftInfo]);



  // 土日出勤回数&月間必要稼働時間の更新
  useEffect(() => {
    if (approvedSpecialShift["weekends"] === -1) {
      setWorkableCount(employeeShiftInfo["weekend_workable_days"]);
    } else {
      setWorkableCount(approvedSpecialShift["weekends"]);
    }

    if (approvedSpecialShift["hour"] === -1) {
      setMonthlyMinHours(employeeShiftInfo["monthly_work_hours"]);
      setDefaultMonthlyMinHours(employeeShiftInfo["monthly_work_hours"]);
    } else {
      setMonthlyMinHours(approvedSpecialShift["hour"]);
      setDefaultMonthlyMinHours(approvedSpecialShift["hour"]);
    }

  // eslint-disable-next-line
  }, [approvedSpecialShift])



  // 従業員コードが入力されたときのイベント
  const handleChangeForEmployeeCode = (e) => {
    const inputtedValue = e.target.value;

    if (employeeCodeList.includes(inputtedValue) || [ "A0000", "B0000", "S0000", "T0000", "C0000" ].includes(inputtedValue)) { // ダミー従業員
      setEmployeeCode(inputtedValue);
      setEmployeeCodeIsValid(true);

      if (employeeCode !== inputtedValue) {
        setEmployeeChanged(true);
        setWorkHourValidationIsOK(true);
        setWeekendValidationIsOK(true);
      } else {
        setEmployeeChanged(false);
      }
    } else {
      setEmployeeCodeIsValid(false);
    }
  }


  // シフト入力されたときのイベント
  const handleChangeForShift = (index, event) => {
    const selectedShiftCode = event.target.value;
    let selectedShiftHour;
    if (selectedShiftCode === 'x' || selectedShiftCode === 'pto') {
      selectedShiftHour = '0H';
    } else {
      selectedShiftHour = shiftPattern[selectedShiftCode];
    }

    const newSelectedShiftValues = [...selectedShiftValues];
    newSelectedShiftValues[index] = selectedShiftCode;
    setSelectedShiftValues(newSelectedShiftValues);
    
    const newSelectedShiftHourValues = [...selectedShiftHourValues];
    newSelectedShiftHourValues[index] = selectedShiftHour;
    setSelectedShiftHourValues(newSelectedShiftHourValues);

    // 最低月間必要時間の更新
    const inputtedLeaveCount = newSelectedShiftValues.filter((shift) => shift === 'pto').length;
    const defaultShidtPattern_Jikan = shiftTable[1][1];
    const defaultShidtPattern_num = parseFloat(defaultShidtPattern_Jikan.replace("時間", ""));
    const newMonthlyMinHours = defaultMonthlyMinHours - inputtedLeaveCount * defaultShidtPattern_num;
    setMonthlyMinHours(newMonthlyMinHours);

    // 月間時間数
    const selectedHourValues_int = newSelectedShiftHourValues.map((hour) => {
      const match = hour.match(/^\d+(\.\d+)?/);
      return match ? parseFloat(match[0]) : 0;
    });
    const sum = selectedHourValues_int.reduce((accumulator, currentValue) => {
        return accumulator + currentValue;
    }, 0);
    sum >= newMonthlyMinHours ? setWorkHourValidationIsOK(true) : setWorkHourValidationIsOK(false);

    // 土日出勤回数
    if (employeeShiftInfo["weekend_workable_days"] && employeeShiftInfo["weekend_workable_days"] > 0 && employeeShiftInfo["workable_day"]) {
      const workableDay_Youbi = employeeShiftInfo["workable_day"]; // "土曜" or "日曜" or "土日"
      let targetWeekendIndexList = nextMonthYear[workableDay_Youbi];
      let weekendWorkCount = 0;
      for (let weekendIndex of targetWeekendIndexList) {
        if (newSelectedShiftValues[weekendIndex] !== 'x' && newSelectedShiftValues[weekendIndex] !== 'pto') {
          weekendWorkCount++;
        }
      }
      weekendWorkCount >= workableCount ? setWeekendValidationIsOK(true) : setWeekendValidationIsOK(false);
    }

    // 有給取得日数3日まで
    let paidLeaveCount = 0;
    for (let shift of newSelectedShiftValues) {
      if (shift === 'pto') {
        paidLeaveCount++;
      }
    }
    paidLeaveCount <= 3 ? setPaidLeaveCountIsOK(true) : setPaidLeaveCountIsOK(false);

  };

  
  

  // 送信ボタンクリック時の処理
  const handleSubmitRequstShiftData = async () => {
    const year = nextMonthYear["yyyy"];
    const month = nextMonthYear["mm"];
    const monthStr = month < 10 ? "0" + month : month;

    const docName = `${year}${monthStr}${employeeCode}`;

    const expireAt = new Date();
    expireAt.setDate(expireAt.getDate()+60);

    await setDoc(doc(db, "RequestShifts", docName), {
      "employee_code": employeeCode,
      "location_key": employeeCode[0],
      "position": employeeShiftInfo["position"], // 管理者側シートへ反映用に追加
      "year": year,
      "month": month,
      "requested_shifts": selectedShiftValues,
      "updated_at": new Date(),
      "expire_at": expireAt
    }, { merge: true });
  }


  const saveEmployeePassword = async (pass) => {

    const docName = employeeShiftInfo["id"];
    await setDoc(doc(db, "Employees", docName), {
      "password": pass,
    }, { merge: true })
    setShiftSubmitPassword(pass);

  }

  // 今月、翌月の切替タブ
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };


  // シフヘン送信ボタンクリック時の処理
  const handleSubmitShiftChangeRequst = async (submitDataForFirebase, shiftChangeDataForGChat, timeKey) => {

    const year = submitDataForFirebase["year"];
    const month = submitDataForFirebase["month"];
    const monthStr = month < 10 ? "0" + month : month;
    const docName = `${year}${monthStr}${employeeCode}`;

    // TO DO: 通知先を設定
    let webhookUrl = "";
    const submittedEmpCode = shiftChangeDataForGChat.employee_code;
    if ( [ "A0000", "B0000", "S0000", "T0000", "C0000" ].includes(submittedEmpCode) ) {
      webhookUrl = 'https://chat.googleapis.com/v1/spaces/AAAAa58oiyY/messages?key=AIzaSyDdI0hCZtE6vySjMm-WEfRq3CPzqKqqsHI&token=0R_xYjErz9mO7pwHfUYtFRPg4ywZ-n1HljgXcUoGBtY'; // TEST環境スペース
      // webhookUrl = 'https://chat.googleapis.com/v1/spaces/AAAAc2nJbRE/messages?key=AIzaSyDdI0hCZtE6vySjMm-WEfRq3CPzqKqqsHI&token=Jwaky90SFAY8e4WW5vUM2k_9iUeF94wlovMJ7kBWZy0'; // meスペース
    } else if (submittedEmpCode[0] === "A") {
      webhookUrl = 'https://chat.googleapis.com/v1/spaces/AAAA0oryMiY/messages?key=AIzaSyDdI0hCZtE6vySjMm-WEfRq3CPzqKqqsHI&token=qUcApqf97bg0UbUSqH2QK76YRViBkauBYobnFwOQtf8%3D';
    } else if (submittedEmpCode[0] === "B") {
      webhookUrl = 'https://chat.googleapis.com/v1/spaces/AAAAZ6ofhhU/messages?key=AIzaSyDdI0hCZtE6vySjMm-WEfRq3CPzqKqqsHI&token=w_SfCGjGuYvlo4W9GjA21m40KMqG1iWuyCxglD9ng8w%3D';
    } else if (submittedEmpCode[0] === "S") {
      webhookUrl = 'https://chat.googleapis.com/v1/spaces/AAAAPHkZ7FE/messages?key=AIzaSyDdI0hCZtE6vySjMm-WEfRq3CPzqKqqsHI&token=N-yVzFjKZVfA4QkVzaFeExFA2G8RDd-sGfHeIf-7p8E%3D';
    } else if (submittedEmpCode[0] === "T") {
      webhookUrl = 'https://chat.googleapis.com/v1/spaces/AAAAhr_ZWYE/messages?key=AIzaSyDdI0hCZtE6vySjMm-WEfRq3CPzqKqqsHI&token=qGAWLCw8jSTDhI8Qbrup3PC_ofbKYdYYSNXS3mDbAOM%3D';
    } else if (submittedEmpCode[0] === "C") {
      webhookUrl = 'https://chat.googleapis.com/v1/spaces/AAQAiOjTWhQ/messages?key=AIzaSyDdI0hCZtE6vySjMm-WEfRq3CPzqKqqsHI&token=JGqn8eHsHkMLOMEgyNCh491-Xrzw4GkYsIVQ4RrTnbo';
    }


    const today = new Date();
    const submitYear = today.getFullYear();
    const submitMonth = String(today.getMonth() + 1).padStart(2, '0');
    const submitDay = String(today.getDate()).padStart(2, '0');
    const applicationDate = `${submitYear}/${submitMonth}/${submitDay}`;

    const message = {
      text: `【シフト変更希望申請が届きました】
  \`従業員ID:${submittedEmpCode}\`
  ${applicationDate}
  　MD名　　：${shiftChangeDataForGChat.name}さん
  　所属　　：${shiftChangeDataForGChat.position}
  欠勤対象日：${shiftChangeDataForGChat.absent_date} ${shiftChangeDataForGChat.shift_pattern}
  　代替日　：${shiftChangeDataForGChat.alternative_date} ${shiftChangeDataForGChat.shift_pattern}
  ――▽欠勤理由▽――
  ${shiftChangeDataForGChat.reason}`
    };
  
    try {
      const newShiftChanges = {
        ...shiftChanges,
        [timeKey]: submitDataForFirebase
      }
      // TODO：非コメント化
      setShiftChanges(newShiftChanges);
      await setDoc(doc(db, "ShiftChanges", docName), submitDataForFirebase, { merge: true });
      
      // TODO: 非コメント化
      const response = await fetch(webhookUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(message)
      });

  
      if (!response.ok) {
        throw new Error('シフヘン申請に失敗しました。時間をおいて再度試すか、管理者へ問い合わせてください。');
      }
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  }


  return (
    <div className="App">
      <Container className='App__container'>
        <Header
          year={nextMonthYear["yyyy"]}
          month={nextMonthYear["mm"]}
          employeeCodeIsValid={employeeCodeIsValid}
          minWorkHour={monthlyMinHours}
          workableDay_Youbi={employeeShiftInfo["workable_day"] || "土日"}
          weekendAvailableCount={workableCount}
          shiftTable={shiftTable}
          updatedAt={updatedAt}
          handleChangeForEmployeeCode={handleChangeForEmployeeCode}
          activeTab={activeTab}
          handleTabChange={handleTabChange}
        />
        { activeTab === "next" ? 
          <Main
            year={nextMonthYear["yyyy"]}
            month={nextMonthYear["mm"]}
            employeeCodeIsValid={employeeCodeIsValid}
            hasRegisteredShifts={hasRegisteredShifts}
            pastDeadLine={pastDeadLine}
            shiftPattern={shiftPattern}
            selectedShiftValues={selectedShiftValues}
            handleChangeForShift={handleChangeForShift}
          /> : 
          <ShiftChangeRequestForm 
            employeeCode={employeeCode || ""}
            position={employeeShiftInfo["position"] || ""}
            name={employeeShiftInfo["name"] || ""}
            shiftChanges={shiftChanges}
            shiftOptionList={shiftOptionList || []}
            handleSubmitShiftChangeRequst={handleSubmitShiftChangeRequst}
            shiftSubmitPassword={shiftSubmitPassword}
            setPasswordPopupOpen={setPasswordPopupOpen}
            shiftChangeLimitEmps={shiftChangeLimitEmps}
          />
        }
        {
          activeTab === "next" &&
            <Footer
              employeeCode={employeeCode}
              employeeCodeIsValid={employeeCodeIsValid}
              hasRegisteredShifts={hasRegisteredShifts}
              pastDeadLine={pastDeadLine}
              workHourValidationIsOK={workHourValidationIsOK}
              weekendValidationIsOK={weekendValidationIsOK}
              paidLeaveCountIsOK={paidLeaveCountIsOK}
              shiftSubmitPassword={shiftSubmitPassword}
              handleSubmitRequstShiftData={handleSubmitRequstShiftData}
              setPasswordPopupOpen={setPasswordPopupOpen}
            />
        }
        {
          passwordPopupOpen && 
          <PasswordPopup 
            passwordPopupOpen={passwordPopupOpen}
            setPasswordPopupOpen={setPasswordPopupOpen}
            saveEmployeePassword={saveEmployeePassword} 
          />
        }
        
      </Container>
    </div>
  )
}


export default App;
